import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef } from "react";
import { EditIcon, RemoveRedEye, Debug, Button, SubmitButton, CreatableSelectSM, CanSwitch, useAsyncState } from "../../../../";
import { makeStyles } from "@material-ui/styles";
import { Typography, Chip, Grid, Divider } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    my12: {
      margin: "12px 0"
    },
    my24: {
      margin: "24px 0"
    },
    mt8: {
      marginTop: "8px"
    },
    mb8: {
      marginBottom: "8px"
    },
    containerFlexNoWrap: {
      display: "flex",
      flexFlow: "row nowrap"
    },
    containerLanguages: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between"
    },
    containerFlexWrap: {
      display: "flex",
      flexFlow: "row wrap",
      alignItems: "center"
    },
    containerContent: {
      padding: "12px 0"
    },
    chipGroup: {
      border: "1px solid ".concat(theme.palette.text.primary),
      borderRadius: "8px",
      background: theme.palette.background.paper,
      margin: "4px"
    },
    linkIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "inherit"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    iconLanguage: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    flexGrow: {
      flex: "1"
    },
    editIcon: {
      color: "#ffe082"
    },
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    pl8: {
      paddingLeft: "8px"
    },
    pr8: {
      paddingRight: "8px"
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    }
  };
});

var MobileCampusProfileTabInformation = function MobileCampusProfileTabInformation(props) {
  // console.log("MobileCampusProfileTabInformation props", props);
  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      typeView = _useState2[0],
      setTypeView = _useState2[1];

  var classes = useStyles();
  var inputCertificate = useRef();

  var _useAsyncState = useAsyncState(""),
      _useAsyncState2 = _slicedToArray(_useAsyncState, 2),
      certificateSelected = _useAsyncState2[0],
      setCertificateSelected = _useAsyncState2[1];

  var handleAddLinkCertificate = function handleAddLinkCertificate(file, index, setFieldValue) {
    // console.log("library handle link certificate", file, index);
    props.data.handleAddLinkCertificate(file).then(function (link) {
      // console.log("response in library link", link);
      setFieldValue("certificates[".concat(index, "].fileRoute"), link);
    });
  };

  var createContentTypeStaffCoordinatorView = function createContentTypeStaffCoordinatorView() {
    var content;

    switch (typeView) {
      case "view":
        content = /*#__PURE__*/React.createElement("div", {
          className: classes.containerContent
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.flexGrow
        }, props.data ? props.data.name || "" : ""), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            setTypeView("edit");
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.phone || "Phone" : "Phone" : "Phone"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.phone || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.email || "Email" : "Email" : "Email"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.email || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.identification_number || "Identification Number" : "Identification Number" : "Identification Number"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.identificationNumber || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.ssn || "SSN" : "SSN" : "SSN"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.ssn || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.bank_account_number || "Bank Account" : "Bank Account" : "Bank Account"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.bankAccountNumber || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary",
          className: classes.mb8
        }, props.translation ? props.translation.titles ? props.translation.titles.sports.can_teach || "Sports Can Teach" : "Sports Can Teach" : "Sports Can Teach"), props.data ? props.data.sports ? props.data.sports.canTeach ? props.data.sports.canTeach.map(function (sport) {
          return /*#__PURE__*/React.createElement(Chip, {
            label: sport,
            className: classes.chipGroup
          });
        }) || null : null : null : null), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.containerFlexNoWrap, classes.mb8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary",
          className: classes.flexGrow
        }, props.translation ? props.translation.titles ? props.translation.titles.certificates || "Certificates" : "Certificates" : "Certificates"), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            setTypeView("edit_certificates");
          }
        })), props.data ? props.data.certificates ? props.data.certificates.map(function (certificate) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.containerFlexNoWrap
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidth
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, certificate.name)), /*#__PURE__*/React.createElement("div", {
            className: classes.icon
          }, /*#__PURE__*/React.createElement(RemoveRedEye, {
            fontSize: "small",
            onClick: function onClick() {
              props.data.handleViewCertificate(certificate.fileRoute).then(function (link) {
                // console.log("link", link);
                window.open(link, "_blank");
              });
            }
          })));
        }) || null : null : null), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary"
        }, props.translation ? props.translation.titles ? props.translation.titles.languages || "Languages" : "Languages" : "Languages"), /*#__PURE__*/React.createElement("div", {
          className: classes.containerLanguages
        }, props.data ? props.data.languages ? props.data.languages.map(function (language) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.iconLanguage,
            onClick: function onClick() {
              return props.data.handleChangeLanguage(language.value);
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: language.valueImage,
            alt: language.value,
            style: {
              width: "40px"
            }
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: props.data.languageSelected === language.value ? "body1" : "body2",
            color: props.data.languageSelected === language.value ? "primary" : "inherit"
          }, language.text));
        }) : null : null)));
        break;

      case "edit":
        var initialValuesCoordinator = {
          name: "",
          phone: "",
          email: "",
          identificationNumber: "",
          ssn: "",
          bankAccountNumber: ""
        };
        var coordinatorSchema = Yup.object().shape({
          name: Yup.string().required(),
          phone: Yup.string().required(),
          email: Yup.string().email().required(),
          identificationNumber: Yup.string(),
          ssn: Yup.string(),
          bankAccountNumber: Yup.string()
        });
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: props.data || initialValuesCoordinator,
          validationSchema: coordinatorSchema,
          onSubmit: function onSubmit(values) {
            var finalValues = _objectSpread(_objectSpread({}, values), {}, {
              changes: {
                nameOrPhone: false,
                staffInfo: false,
                sports: {
                  canTeach: false
                }
              }
            });

            if (props.data.name !== values.name || props.data.phone !== values.phone) {
              finalValues.changes.nameOrPhone = true;
            }

            if (props.data.identificationNumber !== values.identificationNumber || props.data.ssn !== values.ssn || props.data.bankAccountNumber !== values.bankAccountNumber) {
              finalValues.changes.staffInfo = true;
            }

            if (!_.isEqual(props.data.sports.canTeach, values.sports.canTeach)) {
              finalValues.changes.sports.canTeach = true;
            }

            props.data.handleSubmitEditInformationCoordinator(finalValues);
            setTypeView("view");
          },
          render: function render(_ref) {
            var values = _ref.values,
                isValid = _ref.isValid,
                isSubmitting = _ref.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
              name: "phone",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.email || "Email" : "Email" : "Email",
              name: "email",
              disabled: true,
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.identification_number || "Identification Number" : "Identification Number" : "Identification Number",
              name: "identificationNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.ssn || "SSN" : "SSN" : "SSN",
              name: "ssn",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.bank_account_number || "Bank Account Number" : "Bank Account Number" : "Bank Account Number",
              name: "bankAccountNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.my12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.titles ? props.translation.titles.sports.can_teach || "Sports Can Teach" : "Sports Can Teach" : "Sports Can Teach"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              name: "sports.canTeach",
              key: "sports",
              component: CreatableSelectSM,
              label: props.translation ? props.translation.selects ? props.translation.selects.sports || "Sports" : "Sports" : "Sports",
              options: values.sports ? values.sports.canTeach ? values.sports.canTeach.map(function (sport) {
                return {
                  label: sport,
                  value: sport
                };
              }) : [] : [],
              variant: "outlined",
              isMulti: true
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save")));
          }
        });
        break;

      case "edit_certificates":
        var initialValuesCertificates = {
          certificates: []
        };
        var certificateSchema = Yup.object().shape({
          certificates: Yup.array().of(Yup.object().shape({
            name: Yup.string().required(),
            fileRoute: Yup.string().required()
          }))
        });
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: props.data || initialValuesCertificates,
          validationSchema: certificateSchema,
          onSubmit: function onSubmit(values) {
            var certificates = [];
            props.data.certificates.forEach(function (certificate) {
              var auxCertificate = values.certificates.find(function (_certificate) {
                return _certificate._id === certificate._id;
              });

              if (auxCertificate) {
                // EDITED
                if (auxCertificate.name !== certificate.name) {
                  certificates.push(_objectSpread(_objectSpread({}, auxCertificate), {}, {
                    action: "edit"
                  }));
                }
              } else {
                // DELETED
                certificates.push(_objectSpread(_objectSpread({}, auxCertificate), {}, {
                  action: "delete"
                }));
              }
            }); // CHECK ADDED

            values.certificates.filter(function (certificate) {
              return !certificate._id;
            }).forEach(function (certificate) {
              certificates.push(_objectSpread(_objectSpread({}, certificate), {}, {
                action: "add"
              }));
            }); // console.log("certificates library", certificates);

            props.data.handleSubmitCertificate(certificates);
            setTypeView("view");
          },
          render: function render(_ref2) {
            var values = _ref2.values,
                isValid = _ref2.isValid,
                isSubmitting = _ref2.isSubmitting,
                setFieldValue = _ref2.setFieldValue;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2,
              className: classes.containerContent
            }, /*#__PURE__*/React.createElement("input", {
              type: "file",
              style: {
                display: "none"
              },
              ref: inputCertificate,
              onChange: function onChange(e) {
                handleAddLinkCertificate(e.target.files[0], certificateSelected, setFieldValue);
              }
            }), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(FieldArray, {
              name: "certificates",
              render: function render(_ref3) {
                var insert = _ref3.insert,
                    remove = _ref3.remove,
                    push = _ref3.push;
                return values.certificates.length > 0 ? values.certificates.map(function (field, index, arr) {
                  return /*#__PURE__*/React.createElement(Grid, {
                    container: true,
                    alignItems: "center",
                    spacing: 2,
                    key: index
                  }, /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12,
                    className: classes.actions
                  }, /*#__PURE__*/React.createElement(Typography, {
                    variant: "body1",
                    className: classes.mr30
                  }, props.translation ? props.translation.texts ? props.translation.texts.certificate || "Certificate" : "Certificate" : "Certificate"), /*#__PURE__*/React.createElement(Button, {
                    key: "delete",
                    className: classes.button,
                    type: "button",
                    color: "secondary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return remove(index);
                    }
                  }, "-")), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "certificates[".concat(index, "].name"),
                    key: "certificates[".concat(index, "].name"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
                    component: TextField,
                    margin: "normal",
                    fullWidth: true,
                    type: "text",
                    variant: "outlined"
                  })), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12,
                    className: classes.actions
                  }, /*#__PURE__*/React.createElement(Button, {
                    variant: !values.certificates[index].fileRoute ? "outlined" : "contained",
                    onClick: function onClick() {
                      setCertificateSelected(index).then(function (x) {
                        inputCertificate.current.click();
                      });
                    },
                    disabled: !values.certificates[index].fileRoute ? false : true
                  }, !values.certificates[index].fileRoute ? props.translation ? props.translation.buttons ? props.translation.buttons.certificate ? props.translation.buttons.certificate.add || "Add certificate" : "Add certificate" : "Add certificate" : "Add certificate" : props.translation ? props.translation.buttons ? props.translation.buttons.certificate ? props.translation.buttons.certificate.added || "Certificate added" : "Certificate added" : "Certificate added" : "Certificate added"), arr.length - 1 === index && /*#__PURE__*/React.createElement(Button, {
                    key: "add",
                    type: "button",
                    className: classes.mt8,
                    size: "small",
                    color: "primary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return push({
                        name: "",
                        fileRoute: ""
                      });
                    }
                  }, "+")), arr.length > 1 && arr.length - 1 !== index && /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Divider, {
                    className: classes.divider
                  })));
                }) : /*#__PURE__*/React.createElement(Button, {
                  key: "add",
                  type: "button",
                  className: classes.mr30,
                  size: "small",
                  color: "primary",
                  variant: "outlined",
                  onClick: function onClick() {
                    return push({
                      name: "",
                      fileRoute: ""
                    });
                  }
                }, props.translation ? props.translation.buttons ? props.translation.buttons.add_certificate || "Add certificate" : "Add certificate" : "Add certificate");
              }
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: [classes.actions, classes.mt8].join(" ")
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save")));
          }
        });
        break;

      default:
        break;
    }

    return content;
  };

  var createContentTypeStaffTrainerView = function createContentTypeStaffTrainerView() {
    var content;

    switch (typeView) {
      case "view":
        content = /*#__PURE__*/React.createElement("div", {
          className: classes.containerContent
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.flexGrow
        }, props.data ? props.data.name || "" : ""), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            setTypeView("edit");
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.phone || "Phone" : "Phone" : "Phone"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.phone || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.email || "Email" : "Email" : "Email"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.email || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.identification_number || "Identification Number" : "Identification Number" : "Identification Number"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.identificationNumber || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.ssn || "SSN" : "SSN" : "SSN"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.ssn || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.bank_account_number || "Bank Account" : "Bank Account" : "Bank Account"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.bankAccountNumber || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary",
          className: classes.mb8
        }, props.translation ? props.translation.titles ? props.translation.titles.sports.can_teach || "Sports Can Teach" : "Sports Can Teach" : "Sports Can Teach"), props.data ? props.data.sports ? props.data.sports.canTeach ? props.data.sports.canTeach.map(function (sport) {
          return /*#__PURE__*/React.createElement(Chip, {
            label: sport,
            className: classes.chipGroup
          });
        }) || null : null : null : null), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement("div", {
          className: [classes.containerFlexNoWrap, classes.mb8].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary",
          className: classes.flexGrow
        }, props.translation ? props.translation.titles ? props.translation.titles.certificates || "Certificates" : "Certificates" : "Certificates"), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            setTypeView("edit_certificates");
          }
        })), props.data ? props.data.certificates ? props.data.certificates.map(function (certificate) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.containerFlexNoWrap
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.textFlexWidth
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, certificate.name)), /*#__PURE__*/React.createElement("div", {
            className: classes.icon
          }, /*#__PURE__*/React.createElement(RemoveRedEye, {
            fontSize: "small",
            onClick: function onClick() {
              props.data.handleViewCertificate(certificate.fileRoute).then(function (link) {
                // console.log("link", link);
                window.open(link, "_blank");
              });
            }
          })));
        }) || null : null : null), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary"
        }, props.translation ? props.translation.titles ? props.translation.titles.languages || "Languages" : "Languages" : "Languages"), /*#__PURE__*/React.createElement("div", {
          className: classes.containerLanguages
        }, props.data ? props.data.languages ? props.data.languages.map(function (language) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.iconLanguage,
            onClick: function onClick() {
              return props.data.handleChangeLanguage(language.value);
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: language.valueImage,
            alt: language.value,
            style: {
              width: "40px"
            }
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: props.data.languageSelected === language.value ? "body1" : "body2",
            color: props.data.languageSelected === language.value ? "primary" : "inherit"
          }, language.text));
        }) : null : null)));
        break;

      case "edit":
        var initialValuesCoordinator = {
          name: "",
          phone: "",
          email: "",
          identificationNumber: "",
          ssn: "",
          bankAccountNumber: ""
        };
        var coordinatorSchema = Yup.object().shape({
          name: Yup.string().required(),
          phone: Yup.string().required(),
          email: Yup.string().email().required(),
          identificationNumber: Yup.string(),
          ssn: Yup.string(),
          bankAccountNumber: Yup.string()
        });
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: props.data || initialValuesCoordinator,
          validationSchema: coordinatorSchema,
          onSubmit: function onSubmit(values) {
            var finalValues = _objectSpread(_objectSpread({}, values), {}, {
              changes: {
                nameOrPhone: false,
                staffInfo: false,
                sports: {
                  canTeach: false
                }
              }
            });

            if (props.data.name !== values.name || props.data.phone !== values.phone) {
              finalValues.changes.nameOrPhone = true;
            }

            if (props.data.identificationNumber !== values.identificationNumber || props.data.ssn !== values.ssn || props.data.bankAccountNumber !== values.bankAccountNumber) {
              finalValues.changes.staffInfo = true;
            }

            if (!_.isEqual(props.data.sports.canTeach, values.sports.canTeach)) {
              finalValues.changes.sports.canTeach = true;
            }

            props.data.handleSubmitEditInformationTrainer(finalValues);
            setTypeView("view");
          },
          render: function render(_ref4) {
            var values = _ref4.values,
                isValid = _ref4.isValid,
                isSubmitting = _ref4.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
              name: "phone",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.email || "Email" : "Email" : "Email",
              name: "email",
              disabled: true,
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.identification_number || "Identification Number" : "Identification Number" : "Identification Number",
              name: "identificationNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.ssn || "SSN" : "SSN" : "SSN",
              name: "ssn",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.bank_account_number || "Bank Account Number" : "Bank Account Number" : "Bank Account Number",
              name: "bankAccountNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.my12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.titles ? props.translation.titles.sports.can_teach || "Sports Can Teach" : "Sports Can Teach" : "Sports Can Teach"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              name: "sports.canTeach",
              key: "sports",
              component: CreatableSelectSM,
              label: props.translation ? props.translation.selects ? props.translation.selects.sports || "Sports" : "Sports" : "Sports",
              options: values.sports ? values.sports.canTeach ? values.sports.canTeach.map(function (sport) {
                return {
                  label: sport,
                  value: sport
                };
              }) : [] : [],
              variant: "outlined",
              isMulti: true
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Edit" : "Edit" : "Edit")));
          }
        });
        break;

      case "edit_certificates":
        var initialValuesCertificates = {
          certificates: []
        };
        var certificateSchema = Yup.object().shape({
          certificates: Yup.array().of(Yup.object().shape({
            name: Yup.string().required(),
            fileRoute: Yup.string().required()
          }))
        });
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: props.data || initialValuesCertificates,
          validationSchema: certificateSchema,
          onSubmit: function onSubmit(values) {
            var certificates = [];
            props.data.certificates.forEach(function (certificate) {
              var auxCertificate = values.certificates.find(function (_certificate) {
                return _certificate._id === certificate._id;
              });

              if (auxCertificate) {
                // EDITED
                if (auxCertificate.name !== certificate.name) {
                  certificates.push(_objectSpread(_objectSpread({}, auxCertificate), {}, {
                    action: "edit"
                  }));
                }
              } else {
                // DELETED
                certificates.push(_objectSpread(_objectSpread({}, auxCertificate), {}, {
                  action: "delete"
                }));
              }
            }); // CHECK ADDED

            values.certificates.filter(function (certificate) {
              return !certificate._id;
            }).forEach(function (certificate) {
              certificates.push(_objectSpread(_objectSpread({}, certificate), {}, {
                action: "add"
              }));
            }); // console.log("certificates library", certificates);

            props.data.handleSubmitCertificate(certificates);
            setTypeView("view");
          },
          render: function render(_ref5) {
            var values = _ref5.values,
                isValid = _ref5.isValid,
                isSubmitting = _ref5.isSubmitting,
                setFieldValue = _ref5.setFieldValue;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2,
              className: classes.containerContent
            }, /*#__PURE__*/React.createElement("input", {
              type: "file",
              style: {
                display: "none"
              },
              ref: inputCertificate,
              onChange: function onChange(e) {
                handleAddLinkCertificate(e.target.files[0], certificateSelected, setFieldValue);
              }
            }), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(FieldArray, {
              name: "certificates",
              render: function render(_ref6) {
                var insert = _ref6.insert,
                    remove = _ref6.remove,
                    push = _ref6.push;
                return values.certificates.length > 0 ? values.certificates.map(function (field, index, arr) {
                  return /*#__PURE__*/React.createElement(Grid, {
                    container: true,
                    alignItems: "center",
                    spacing: 2,
                    key: index
                  }, /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12,
                    className: classes.actions
                  }, /*#__PURE__*/React.createElement(Typography, {
                    variant: "body1",
                    className: classes.mr30
                  }, props.translation ? props.translation.texts ? props.translation.texts.certificate || "Certificate" : "Certificate" : "Certificate"), /*#__PURE__*/React.createElement(Button, {
                    key: "delete",
                    className: classes.button,
                    type: "button",
                    color: "secondary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return remove(index);
                    }
                  }, "-")), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "certificates[".concat(index, "].name"),
                    key: "certificates[".concat(index, "].name"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
                    component: TextField,
                    margin: "normal",
                    fullWidth: true,
                    type: "text",
                    variant: "outlined"
                  })), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12,
                    className: classes.actions
                  }, /*#__PURE__*/React.createElement(Button, {
                    variant: !values.certificates[index].fileRoute ? "outlined" : "contained",
                    onClick: function onClick() {
                      setCertificateSelected(index).then(function (x) {
                        inputCertificate.current.click();
                      });
                    },
                    disabled: !values.certificates[index].fileRoute ? false : true
                  }, !values.certificates[index].fileRoute ? props.translation ? props.translation.buttons ? props.translation.buttons.certificate ? props.translation.buttons.certificate.add || "Add certificate" : "Add certificate" : "Add certificate" : "Add certificate" : props.translation ? props.translation.buttons ? props.translation.buttons.certificate ? props.translation.buttons.certificate.added || "Certificate added" : "Certificate added" : "Certificate added" : "Certificate added"), arr.length - 1 === index && /*#__PURE__*/React.createElement(Button, {
                    key: "add",
                    type: "button",
                    className: classes.mt8,
                    size: "small",
                    color: "primary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return push({
                        name: "",
                        fileRoute: ""
                      });
                    }
                  }, "+")), arr.length > 1 && arr.length - 1 !== index && /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Divider, {
                    className: classes.divider
                  })));
                }) : /*#__PURE__*/React.createElement(Button, {
                  key: "add",
                  type: "button",
                  className: classes.mr30,
                  size: "small",
                  color: "primary",
                  variant: "outlined",
                  onClick: function onClick() {
                    return push({
                      name: "",
                      fileRoute: ""
                    });
                  }
                }, props.translation ? props.translation.buttons ? props.translation.buttons.add_certificate || "Add certificate" : "Add certificate" : "Add certificate");
              }
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: [classes.actions, classes.mt8].join(" ")
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save")));
          }
        });
        break;

      default:
        break;
    }

    return content;
  };

  var createContentTypeStaffParentView = function createContentTypeStaffParentView() {
    var content;

    switch (typeView) {
      case "view":
        content = /*#__PURE__*/React.createElement("div", {
          className: classes.containerContent
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.containerFlexNoWrap
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.flexGrow
        }, props.data ? props.data.name || "" : ""), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            setTypeView("edit");
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.phone || "Phone" : "Phone" : "Phone"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.phone || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: [classes.my12, classes.containerFlexWrap].join(" ")
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.labels ? props.translation.labels.email || "Email" : "Email" : "Email"), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          className: classes.pl8
        }, props.data ? props.data.email || "" : "")), /*#__PURE__*/React.createElement("div", {
          className: classes.my24
        }, /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "primary"
        }, props.translation ? props.translation.titles ? props.translation.titles.languages || "Languages" : "Languages" : "Languages"), /*#__PURE__*/React.createElement("div", {
          className: classes.containerLanguages
        }, props.data ? props.data.languages ? props.data.languages.map(function (language) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.iconLanguage,
            onClick: function onClick() {
              return props.data.handleChangeLanguage(language.value);
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: language.valueImage,
            alt: language.value,
            style: {
              width: "40px"
            }
          }), /*#__PURE__*/React.createElement(Typography, {
            variant: props.data.languageSelected === language.value ? "body1" : "body2",
            color: props.data.languageSelected === language.value ? "primary" : "inherit"
          }, language.text));
        }) : null : null)));
        break;

      case "edit":
        var initialValuesParent = {
          name: "",
          phone: "",
          email: ""
        };
        var parentSchema = Yup.object().shape({
          name: Yup.string().required(),
          phone: Yup.string().required()
        });
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: props.data || initialValuesParent,
          validationSchema: parentSchema,
          onSubmit: function onSubmit(values) {
            props.data.handleSubmitEditInformationParent(values);
            setTypeView("view");
          },
          render: function render(_ref7) {
            var values = _ref7.values,
                isValid = _ref7.isValid,
                isSubmitting = _ref7.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
              name: "phone",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Edit" : "Edit" : "Edit")));
          }
        });
        break;

      default:
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(CanSwitch, {
    role: props.role,
    coordinator: function coordinator() {
      return createContentTypeStaffCoordinatorView();
    },
    trainer: function trainer() {
      return createContentTypeStaffTrainerView();
    },
    parent: function parent() {
      return createContentTypeStaffParentView();
    }
  });
};

export { MobileCampusProfileTabInformation };